var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockPayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 7.75V4.75C3.75 2.54 5.54 0.75 7.75 0.75C9.96 0.75 11.75 2.54 11.75 4.75V7.75M7.75 12.75C8.01522 12.75 8.26957 12.6446 8.45711 12.4571C8.64464 12.2696 8.75 12.0152 8.75 11.75C8.75 11.4848 8.64464 11.2304 8.45711 11.0429C8.26957 10.8554 8.01522 10.75 7.75 10.75C7.48478 10.75 7.23043 10.8554 7.04289 11.0429C6.85536 11.2304 6.75 11.4848 6.75 11.75C6.75 12.0152 6.85536 12.2696 7.04289 12.4571C7.23043 12.6446 7.48478 12.75 7.75 12.75ZM7.75 12.75V15.75M2.35 7.75H13.15C14.03 7.75 14.75 8.47 14.75 9.35V16.35C14.75 17.67 13.67 18.75 12.35 18.75H3.15C1.83 18.75 0.75 17.67 0.75 16.35V9.35C0.75 8.47 1.47 7.75 2.35 7.75Z",
    stroke: "#D92D20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockPayout);
export default __webpack_public_path__ + "static/media/lock-payout.830763f58d216e6402c1eb1e1dc63420.svg";
export { ForwardRef as ReactComponent };